var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9643 1H10.4643C10.4054 1 10.3571 1.04821 10.3571 1.10714V2.10714C10.3571 2.16607 10.4054 2.21429 10.4643 2.21429H13.3286L9.76964 5.77321C8.87679 5.08571 7.7875 4.71429 6.64286 4.71429C5.26964 4.71429 3.97679 5.25 3.00714 6.22143C2.0375 7.19286 1.5 8.48393 1.5 9.85714C1.5 11.2304 2.03571 12.5232 3.00714 13.4929C3.97679 14.4643 5.26964 15 6.64286 15C8.01607 15 9.30893 14.4643 10.2786 13.4929C11.25 12.5232 11.7857 11.2304 11.7857 9.85714C11.7857 8.7125 11.4143 7.62679 10.7286 6.73393L14.2857 3.17679V6.03572C14.2857 6.09464 14.3339 6.14286 14.3929 6.14286H15.3929C15.4518 6.14286 15.5 6.09464 15.5 6.03572V1.53571C15.5 1.24107 15.2589 1 14.9643 1ZM6.64286 13.6429C4.55536 13.6429 2.85714 11.9446 2.85714 9.85714C2.85714 7.76964 4.55536 6.07143 6.64286 6.07143C8.73036 6.07143 10.4286 7.76964 10.4286 9.85714C10.4286 11.9446 8.73036 13.6429 6.64286 13.6429Z",
    fill: "#1890FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManIcon);
export default __webpack_public_path__ + "static/media/Man_icon.8db932bad8353ca54fbdf12761fcad99.svg";
export { ForwardRef as ReactComponent };